/*
  RareCut Magnetic + Tilt — pointer-driven micro-interactions layered on top
  of rc-interactive.css's shine/lift pass: primary CTAs get pulled toward the
  cursor with a bolder scale-up, product/collection cards get a 3D tilt. Both
  also feed --rc-spot-x/--rc-spot-y custom properties that drive the cursor-
  following spotlight glow defined in rc-interactive.css. Wired the same way
  as rc-global-reveal.js (tag-once + MutationObserver) so buttons and cards
  added later (quick-add modal, filtered grids, cart drawer) still pick it
  up. Pointer-driven only (hover:hover + pointer:fine) and fully inert under
  prefers-reduced-motion.
*/
(function () {
  if (window.__rcMagnetic) return;
  window.__rcMagnetic = true;

  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!canHover || reduced) return;

  var SNAP_BACK = 'transform .5s cubic-bezier(.22,1,.36,1)';
  var MAGNET_MAX = 16;
  var TILT_MAX_DEG = 9;

  // lift/scale hover-effect modes already claim the card's transform on
  // hover; tilt would fight them, so only subtle-zoom (the theme default)
  // gets the 3D tilt treatment.
  var tiltEligible = !document.body.classList.contains('card-hover-effect-lift') &&
    !document.body.classList.contains('card-hover-effect-scale');

  function wireMagnet(el) {
    if (el.hasAttribute('data-rc-magnetic')) return;
    el.setAttribute('data-rc-magnetic', '');
    var raf = null;

    el.addEventListener('pointerenter', function () {
      el.style.transition = 'none';
    });
    el.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rect = el.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        var x = relX * MAGNET_MAX * 2;
        var y = relY * MAGNET_MAX;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px) scale(1.045)';
        el.style.setProperty('--rc-spot-x', ((relX + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--rc-spot-y', ((relY + 0.5) * 100).toFixed(1) + '%');
      });
    });
    el.addEventListener('pointerleave', function () {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
      el.style.transition = SNAP_BACK;
      el.style.transform = 'translate(0,0) scale(1)';
    });
  }

  function wireTilt(el) {
    if (el.hasAttribute('data-rc-tilt')) return;
    el.setAttribute('data-rc-tilt', '');
    var raf = null;

    el.addEventListener('pointerenter', function () {
      el.style.transition = 'none';
    });
    el.addEventListener('pointermove', function (e) {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var rect = el.getBoundingClientRect();
        var relX = (e.clientX - rect.left) / rect.width - 0.5;
        var relY = (e.clientY - rect.top) / rect.height - 0.5;
        var rotY = relX * TILT_MAX_DEG * 2;
        var rotX = relY * -1 * TILT_MAX_DEG * 2;
        el.style.transform =
          'perspective(900px) rotateX(' + rotX.toFixed(2) + 'deg) rotateY(' + rotY.toFixed(2) + 'deg) scale(1.02)';
        el.style.setProperty('--rc-spot-x', ((relX + 0.5) * 100).toFixed(1) + '%');
        el.style.setProperty('--rc-spot-y', ((relY + 0.5) * 100).toFixed(1) + '%');
      });
    });
    el.addEventListener('pointerleave', function () {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
      el.style.transition = SNAP_BACK;
      el.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg) scale(1)';
    });
  }

  function tag() {
    var magnets = document.querySelectorAll(
      '.button:not(.button-unstyled, .skip-to-content-link), .button-secondary:not(.button-unstyled, .skip-to-content-link)'
    );
    for (var i = 0; i < magnets.length; i++) wireMagnet(magnets[i]);

    if (tiltEligible) {
      var cards = document.querySelectorAll('.product-card, .collection-card');
      for (var j = 0; j < cards.length; j++) wireTilt(cards[j]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tag, { once: true });
  } else {
    tag();
  }

  var pending = false;
  function scheduleTag() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      tag();
    });
  }

  var mo = new MutationObserver(scheduleTag);
  mo.observe(document.body, { childList: true, subtree: true });
})();
